import { Box } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { HeaderLayout } from '../components/HeaderLayout';
import { Footer } from '../components/Footer';
import { ProfileSidebar } from './profile/Sidebar';

// Decode the JWT payload (no signature check — the backend verifies). Used to
// surface claims authkit-react doesn't expose via useAuth(), notably org_name.
// Tolerant of malformed tokens: returns null on any failure.
// function decodeJwtPayload(token: string): Record<string, unknown> | null {
//   try {
//     const parts = token.split('.');
//     if (parts.length < 2) return null;
//     const b64 = parts[1].replaceAll('-', '+').replaceAll('_', '/');
//     const json = atob(b64);
//     return JSON.parse(json) as Record<string, unknown>;
//   } catch {
//     return null;
//   }
// }

export function Profile() {
  return (
    <>
      <HeaderLayout />
      <Box
        display="flex"
        w="100%"
        flex={1}
        style={{ overflow: 'hidden' }}
        data-testid="profile-page"
      >
        <ProfileSidebar />

        {/* ── Main content ── */}
        <Outlet />

      </Box>
      <Footer />
    </>
  );
}
